module.exports = __webpack_public_path__ + "img/4.986df21c.jpg";